import { gu_filterCommonKey } from '@utils/general-util';

import { popupConstants } from '../constant';
export const popupAction = {
    popupUpdate,
    setPopupVisible,
    togglePopUp,
    triggerPopupUpdate,
};
const dataCache = {};

function popupUpdate(popupObj) {
    return (dispatch) => {
        Object.assign(dataCache, popupObj.data);

        dispatch({ type: popupConstants.POPUP_UPDATE, payload: { page: popupObj.page, data: dataCache, title: popupObj.title, isDynamicPage: popupObj.isDynamicPage } });
    };
}

function setPopupVisible(flag) {
    return (dispatch) => {
        dispatch({ type: popupConstants.SET_POPUP_VISIBLE, payload: { isActive: flag } });
    };
}

function togglePopUp(popupObj) {
    return (dispatch) => {
        const { popupType, popupProps } = popupObj;
        dispatch({ type: popupConstants.TOGGLE_POPUP, payload: { popupType, popupProps } });
    };
}

function triggerPopupUpdate(page, data, category, title, content, isDynamicPage) {
    return (dispatch) => {
        const popupObj = { page: page, data: {}, isDynamicPage };
        if (data) {
            popupObj.data[category] = data;
        }
        if (content) {
            popupObj.data['content'] = content;
        }
        popupObj.title = gu_filterCommonKey(title) || false;
        dispatch(popupUpdate(popupObj));
    };
}
